
  import { defineComponent, ref } from "vue"
  import styles from "./scss/FindWord.module.scss"

  export default defineComponent({
    name: "FindWord",
    inject: ["Ti18N"],
    emits: {
      findItem: (word: string) => {
        return word.trim().length > 0
      },
      editPage: (num: number) => num == 1
    },
    setup(_: any, { emit }: any) {
      const moduleWords = ref("")
      const getWord = () => {
        emit("findItem", moduleWords.value)
        emit("editPage", 1)
      }

      return { moduleWords, getWord, styles }
    },
  })
